import React from "react";
import WrapperPage from "../../components/WrapperPage";
import BaseLogo from "../../components/BaseLogo";
import ExitModal from "../../modals/ExitModal";
import Ellipses from "../../components/Ellipses";
import BaseMobileHeader from "../../components/BaseMobileHeader";
import "./style.scss";
import { useTranslation } from "react-i18next";
import ManualGame from "../../components/ManualGame";
import BaseButton from "../../components/BaseButton";
import useCustomNavigate from "../../hooks/useCustomNavigate";
import ROUTES from "../../utils/routes.js";

export default function ManualPage() {
  const { navigateTo } = useCustomNavigate();
  const { t } = useTranslation();
  return (
    <div className="manual-page-wrapper centering-page">
      <Ellipses className="manual-page-wrapper-ellipses" countEllipses={2} />
      <ExitModal />
      <BaseMobileHeader isBackBtn={true} />
      <BaseLogo className="manual-page-wrapper__logo" />
      <div className="manual-page-wrapper__main-info">
        <ManualGame />
      </div>
      <BaseButton
        onClick={() => navigateTo(-1)}
        className="manual-page__button-close"
      >
        {t("close_button")}
      </BaseButton>
    </div>
  );
}
